<div class="container-fluid py-4">
    <div class="row mb-4">
        <div class="col-12">
          <h3 class="fw-bold" style="color: #4b4b4b;">App Settings</h3>  
          <p class="text-muted">Manage the global Contact Info and About Text displayed in the mobile applications.</p>
        </div>
    </div>
    
    <div class="row">
        <div class="col-12">
            <!-- Navigation Tabs -->
            <ul class="nav nav-pills mb-4 custom-nav-pills gap-2">
                <li class="nav-item">
                    <a class="nav-link" 
                       [class.active]="activeTab === 'Tourguide'" 
                       (click)="switchTab('Tourguide')" 
                       style="cursor: pointer;">
                       Tourguide App
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" 
                       [class.active]="activeTab === 'Tourist'" 
                       (click)="switchTab('Tourist')" 
                       style="cursor: pointer;">
                       Tourist App
                    </a>
                </li>
            </ul>

            <!-- Settings Form Card -->
            <div class="card border-0 shadow-sm custom-card">
                <div class="card-body p-4 position-relative">
                    
                    <div *ngIf="isLoading" class="loading-overlay">
                        <div class="spinner-border text-primary" role="status">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                    </div>

                    <h5 class="mb-4" style="color: #286676;">{{ activeTab }} App Configuration</h5>

                    <div class="row g-4">
                        <div class="col-md-6">
                            <label class="form-label fw-bold text-muted small">Admin Support Email</label>
                            <div class="input-group">
                                <span class="input-group-text bg-light border-end-0"><i class="bi bi-envelope text-muted"></i></span>
                                <input type="email" class="form-control border-start-0 custom-input pl-0" 
                                       [(ngModel)]="currentData.adminEmail" placeholder="e.g. info@safroo.com">
                            </div>
                        </div>

                        <div class="col-md-6">
                            <label class="form-label fw-bold text-muted small">Admin Support Phone</label>
                            <div class="input-group">
                                <span class="input-group-text bg-light border-end-0"><i class="bi bi-telephone text-muted"></i></span>
                                <input type="text" class="form-control border-start-0 custom-input pl-0" 
                                       [(ngModel)]="currentData.adminPhone" placeholder="e.g. +91987654321">
                            </div>
                        </div>

                        <div class="col-12">
                            <label class="form-label fw-bold text-muted small">About Section Text</label>
                            <textarea class="form-control custom-input" rows="5" 
                                      [(ngModel)]="currentData.aboutText" placeholder="Write something about the Safroo {{ activeTab }} app..."></textarea>
                        </div>
                    </div>

                    <div class="d-flex justify-content-end mt-4 pt-3 border-top">
                        <button class="btn btn-save px-4" (click)="saveSettings()" [disabled]="isSaving || isLoading">
                            <span *ngIf="!isSaving">Save Changes</span>
                            <span *ngIf="isSaving" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        </button>
                    </div>

                </div>
            </div>

        </div>
    </div>
</div>
